import logger from 'logger';

import { getAuthClient } from './clients';

type AuthUser = {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  phone: string | null;
  initials: string;
  creditInCents: number;
};

export async function login(input: {
  email: string;
  password: string;
  rememberMe?: boolean;
  signInLocation?: string;
}): Promise<
  | { ok: true; user: AuthUser }
  | { ok: false; reason: 'invalid_credentials' | 'unknown' }
> {
  const client = getAuthClient();

  let res;
  try {
    res = await client.post<{
      success: boolean;
      data: AuthUser;
      error: {
        code: number | null;
        message: string | null;
        validation: unknown;
      };
    }>('/login', {
      email: input.email,
      password: input.password,
      remember_me: input.rememberMe,
      sign_in_location: input.signInLocation,
    });
  } catch (err: any) {
    const status = err?.response?.status;
    // 401 is the expected response for bad credentials; surface as a typed
    // result rather than logging.
    if (status === 401) {
      return { ok: false, reason: 'invalid_credentials' };
    }
    logger.error({
      msg: 'LoginRequestFailed',
      noticable: err,
      extra: { context: { status } },
    });
    return { ok: false, reason: 'unknown' };
  }

  if (!res.data?.success || !res.data?.data) {
    const err = new Error('login response did not include user data');
    logger.error({
      msg: 'LoginNonOkResponse',
      noticable: err,
    });
    return { ok: false, reason: 'unknown' };
  }

  return { ok: true, user: res.data.data };
}
